export type AdminUserStatus = 'Active' | 'Inactive' | 'PendingActivation';

export interface AdminUserListDto {
  id: string;
  email: string;
  displayName: string | null;
  roleName: string;
  isActive: boolean;
  isPasswordConfigured: boolean;
  status: AdminUserStatus;
  lastLoginAt: string | null;
}

export interface CreateAdminUserRequest {
  email: string;
  displayName: string;
  roleId: string;
}

export interface UpdateAdminUserRequest {
  displayName: string;
  email: string;
}

export interface ActivateAdminUserRequest {
  reason: string;
}

export interface DeactivateAdminUserRequest {
  reason: string;
}

export interface ResendInvitationRequest {
  email: string;
}

export interface ChangeAdminUserRoleRequest {
  roleId: string;
}

export interface SetupPasswordRequest {
  token: string;
  password: string;
}

export interface AdminUserDetailDto {
  id: string;
  externalId: string;
  email: string;
  displayName: string | null;
  avatarUrl: string | null;
  isActive: boolean;
  isPasswordConfigured: boolean;
  roleId: string;
  roleName: string;
  permissions: string[];
  createdAt: string;
  lastLoginAt: string | null;
  updatedAt: string;
}

export interface AdminUserListParams {
  page?: number;
  pageSize?: number;
  status?: AdminUserStatus;
  searchTerm?: string;
}

export interface AdminLoginAttemptDto {
  id: string;
  attemptedAt: string;
  success: boolean;
}

export function getAdminUserStatus(user: { isActive: boolean; isPasswordConfigured: boolean }): {
  status: 'active' | 'warning' | 'inactive';
  label: string;
} {
  if (user.isActive) return { status: 'active', label: 'Activo' };
  if (user.isPasswordConfigured) return { status: 'inactive', label: 'Inactivo' };
  return { status: 'warning', label: 'Pendiente de activación' };
}

export const ADMIN_USER_STATUS_LABELS: Record<AdminUserStatus, string> = {
  Active: 'Activo',
  Inactive: 'Inactivo',
  PendingActivation: 'Pendiente de activación',
};

/**
 * Maps the backend `status` enum to a StatusBadge variant + UI label.
 * Prefer this over deriving from `isActive`/`isPasswordConfigured` — the
 * backend already resolves the three states.
 */
export function mapAdminUserStatus(status: AdminUserStatus): {
  status: 'active' | 'warning' | 'inactive';
  label: string;
} {
  switch (status) {
    case 'Active':
      return { status: 'active', label: ADMIN_USER_STATUS_LABELS.Active };
    case 'Inactive':
      return { status: 'inactive', label: ADMIN_USER_STATUS_LABELS.Inactive };
    case 'PendingActivation':
      return { status: 'warning', label: ADMIN_USER_STATUS_LABELS.PendingActivation };
  }
}
